module.exports = __webpack_public_path__ + "img/gongxiao.798b8879.png";